import React from "react";
import { SiBasicattentiontoken } from "react-icons/si";
import { LuCalendar, LuCalendarClock, LuLayoutDashboard } from "react-icons/lu";
import { GiPayMoney } from "react-icons/gi";
import { GrConfigure, GrDocumentText, GrMoney } from "react-icons/gr";
import { HiOutlineAcademicCap } from "react-icons/hi";
import {
  MdListAlt,
  MdOutlineAssignment,
  MdOutlineMedicalServices,
} from "react-icons/md";
import { PiGoogleDriveLogo } from "react-icons/pi";
import { BiBus } from "react-icons/bi";
import { RiListIndefinite } from "react-icons/ri";
import { useSelector } from "react-redux";
import { CiTextAlignCenter } from "react-icons/ci";
import { BsChatText } from "react-icons/bs";
import { HiOutlineChatBubbleLeftEllipsis } from "react-icons/hi2";
import { _userRole } from "../utils/common";

export const USER_SUPER_ADMIN = 0;
export const USER_WORKSPACE_ADMIN = 1;
export const USER_STAFF = 2;
export const USER_STUDENT = 3;

const useUserRole = () => {
  const { role } = useSelector((state) => state.user);

  return React.useMemo(() => {
    switch (role) {
      case USER_WORKSPACE_ADMIN:
        return _userRole.WORKSPACE_ADMIN;
      case USER_STAFF:
        return _userRole.STAFF;
      case USER_STUDENT:
        return _userRole.STUDENT;
      default:
        return null;
    }
  }, [role]);
};

export default useUserRole;
